import type { Tags, HTMLElementSimplified } from '../../types';

export function parseHtmlToJson(doc: Document): Array<HTMLElementSimplified> {
  const htmlElements = Array.from(doc.body.childNodes) as Array<Element>;
  return htmlElements.map((element) => parseElementsToJson(element));
}

function parseElementsToJson(el: Element): HTMLElementSimplified {
  const childEls = el.childNodes?.length
    ? (Array.from(el.childNodes) as Array<Element>)
    : [];

  return {
    tag: (el.tagName ?? el.nodeName) as Tags,
    attributes: getAllAttributes(el),
    classList: el.classList,
    innerHTML: el.innerHTML,
    textContent: el.textContent,
    children: childEls.map((childEl) => parseElementsToJson(childEl)),
    parent: el.parentElement,
  };
}

function getAllAttributes(el: Element) {
  const attributes = {} as Record<string, string>;
  for (let i = 0; i < el.attributes?.length; i++) {
    attributes[el.attributes[i].nodeName] = el.attributes[i].nodeValue;
  }
  return attributes;
}
